/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import {
  CEFR_LEVELS,
  type ICEFRLevel,
  type IProgressCardBucketFilter,
  type IProgressCardStateFilter,
  PROGRESS_CARD_BUCKET_FILTERS,
  PROGRESS_CARD_STATE_FILTERS,
} from '@repo/config';
import { z } from 'zod';

export const PROGRESS_CARDS_MAX_LEVEL = 20;
export const PROGRESS_CARDS_DEFAULT_LIMIT = 24;
export const PROGRESS_CARDS_MAX_LIMIT = 60;

export const getProgressCardsV1RequestSchema = z.object({
  bucket: z.enum(PROGRESS_CARD_BUCKET_FILTERS).optional(),
  level: z.number().int().min(0).max(PROGRESS_CARDS_MAX_LEVEL).nullable().optional(),
  state: z.enum(PROGRESS_CARD_STATE_FILTERS).optional(),
  cefr: z.enum(CEFR_LEVELS).nullable().optional(),
  dueFrom: z.number().int().min(0).nullable().optional(),
  dueTo: z.number().int().min(0).nullable().optional(),
  cursor: z.string().nullable().optional(),
  limit: z.number().int().min(1).max(PROGRESS_CARDS_MAX_LIMIT).optional(),
});

export interface IGetProgressCardsV1Request {
  bucket?: IProgressCardBucketFilter;
  level?: number | null;
  state?: IProgressCardStateFilter;
  cefr?: ICEFRLevel | null;
  dueFrom?: number | null;
  dueTo?: number | null;
  cursor?: string | null;
  limit?: number;
}
